







import {Component, Prop} from 'vue-property-decorator'

import {LatLon} from './models/LatLon'
import NMapChildren from './NMapChildren.vue'


@Component({
  components: {},
})
export default class NMapPolygon extends NMapChildren {
  @Prop() public points!: LatLon[]

  @Prop({default: 4}) public readonly lineWidth!: number
  @Prop({default: '#00ff00'}) public readonly color!: string

  public init() {
    this.item = this.getNMap().providerInstance.addPolygon(
      this.points,
      this.lineWidth,
      this.color,
      this.$slots.default ? this.$slots.default[0].elm : null,
      this.$listeners && this.$listeners.click ? () => {
        this.$emit('click')
      } : () => {})
  }
}
